import { checkDisableForceHistoricalRosters } from "./checkDisableForceHistoricalRosters.ts";
import getLeague from "./getLeague.ts";
import getLeagueInfo from "./getLeagueInfo.ts";
import { getPlayerActiveSeasons } from "./getPlayerActiveSeasons.ts";
import loadData from "./loadData.basketball.ts";
import updateRandomDebutsForever from "./updateRandomDebutsForever.ts";

export default {
	checkDisableForceHistoricalRosters,
	getLeague,
	getLeagueInfo,
	getPlayerActiveSeasons,
	loadData,
	updateRandomDebutsForever,
};
